var _defs, _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMynLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 64",
    role: "img",
    "aria-label": "MYN.CLUB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mynBlueF",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4DA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F7FF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mynGoldF",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 46 V30 a8 8 0 0 1 16 0 V46 M28 30 a8 8 0 0 1 16 0 V46",
    fill: "none",
    stroke: "url(#mynBlueF)",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10 l2.2 4.5 5 .7 -3.6 3.5 .9 5 -4.5-2.4 -4.5 2.4 .9-5 -3.6-3.5 5-.7 Z",
    fill: "url(#mynGoldF)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 42,
    fontFamily: "'Segoe UI', system-ui, -apple-system, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 800,
    letterSpacing: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#1F2D3D"
  }, "MYN"), /*#__PURE__*/React.createElement("tspan", {
    fill: "url(#mynBlueF)"
  }, ".CLUB"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMynLogoFull);
export default __webpack_public_path__ + "static/media/myn-logo-full.927a9df2c0b55d8f0feea42122b48245.svg";
export { ForwardRef as ReactComponent };